const isProduction = false

export default {
  targetSrc: isProduction ? 'https://app.666yiyao.com' : 'https://ppapp.666yiyao.com',
  manageTargetSrc: isProduction ? 'https://manage.666yiyao.com' : 'https://ppmanage.666yiyao.com',
  // targetSrc: "http://47.103.139.130:8080",   //器械接口
  // admin: isProduction?"admin:yuN0ngA1":"admin:admin", //使用上面的会有权限问题，暂未去解决
  admin: isProduction ? 'admin:yuN0ngA1' : 'admin:yuN0ngA1',
  imgUrlPrefix: '/image/item?img_id='
}



// WEBPACK FOOTER //
// ./src/assets/js/environment.js